import { render, staticRenderFns } from "./signatureSettings.vue?vue&type=template&id=4968233d&scoped=true&"
import script from "./signatureSettings.vue?vue&type=script&lang=ts&"
export * from "./signatureSettings.vue?vue&type=script&lang=ts&"
import style0 from "./signatureSettings.vue?vue&type=style&index=0&id=4968233d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4968233d",
  null
  
)

export default component.exports